"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WeekDays = exports.WeekDay = exports.MonthName = exports.MonthGrid = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var MonthGrid = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: ", "rem;\n  display: flex;\n  flex-wrap: wrap;\n  align-self: flex-start;\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return 7 * parseFloat(theme.daySize);
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontFamily;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSize;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.lineHeight;
});
exports.MonthGrid = MonthGrid;
var MonthName = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  font-family: ", ";\n  letter-spacing: ", ";\n  display: flex;\n  flex: 1 1 ", "rem;\n  justify-content: center;\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.monthColor;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.isClassic ? theme.monthNameFontSize : theme.monthYearTypography.fontSize;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.isClassic ? theme.monthNameLineHeight : theme.monthYearTypography.lineHeight;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.isClassic ? theme.monthNameFontWeight : theme.monthYearTypography.fontWeight;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.isClassic ? undefined : theme.monthYearTypography.fontFamily;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.isClassic ? undefined : theme.monthYearTypography.letterSpacing;
}, function (_ref11) {
  var theme = _ref11.theme;
  return 7 * parseFloat(theme.daySize);
});
exports.MonthName = MonthName;
var WeekDays = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  margin-bottom: ", ";\n  border-bottom-width: ", ";\n  border-bottom-style: ", ";\n  border-bottom-color: ", ";\n\n  ", "\n"])), function (_ref12) {
  var theme = _ref12.theme;
  return theme.weekDaysMarginBottom;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.weekDaysBorderWidth;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.weekDaysBorderStyle;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.weekDaysBorderColor;
}, function (_ref16) {
  var theme = _ref16.theme;
  return !theme.isClassic && (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      font-size: ", ";\n      line-height: ", ";\n      font-weight: ", ";\n      font-family: ", ";\n      letter-spacing: ", ";\n    "])), theme.weekdaysTypography.fontSize, theme.weekdaysTypography.lineHeight, theme.weekdaysTypography.fontWeight, theme.weekdaysTypography.fontFamily, theme.weekdaysTypography.letterSpacing);
});
exports.WeekDays = WeekDays;
var WeekDay = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: ", ";\n  height: ", ";\n  color: ", ";\n"])), function (_ref17) {
  var theme = _ref17.theme;
  return theme.daySize;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.daySize;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.weekDayColor;
});
exports.WeekDay = WeekDay;